<template>
	<div
		class="app-auth-window d-flex w-100 h-100 d-flex align-center justify-end auth-bg"
		:class="{
			'justify-end': !(currentUser && !isEmailConfirmed),
			'justify-center': currentUser && !isEmailConfirmed,
		}"
	>
		<template v-if="currentUser && !isEmailConfirmed">
			<v-card
				class="px-13 py-14"
				max-width="421"
				rounded="0"
			>
				<h3 class="text-center w-100 d-flex align-center justify-center font-weight-regular mb-3">
					{{ $t('Please, confirm your email') }}
				</h3>

				<div class="d-flex flex-column align-center justify-center w-100">
					<v-btn
						class="mb-1"
						color="primary"
						@click="logoutUser"
					>
						{{ $t('Logout') }}
					</v-btn>
					<v-btn
						color="primary"
						:loading="resendingState.loading"
						:disabled="resendingState.loading"
						@click="resendConfirmationEmail"
					>
						{{ $t('Send mail again') }}
					</v-btn>
				</div>
			</v-card>
		</template>

		<template v-else>
			<v-card
				class="h-100 w-100 px-13 py-14"
				max-width="421"
				rounded="0"
			>
				<h1 class="text-center w-100 d-flex align-center justify-center font-weight-regular mb-5">
					<img
						src="/logo-full.svg"
						alt=""
						class="w-100 mr-4"
					>
				</h1>

				<v-window v-model="currentTab">
					<v-window-item value="login">
						<LoginForm
							:requestLoading="loginState.loading"
							:extraFieldsErrors="loginState.extraErrors"
							:isVisible="currentTab === 'login'"
							@submit="onLogin"
						/>

						<div class="mt-3">
							<p class="text-caption">
								{{ $t('Not registered?') }}
								<span
									class="text-primary"
									style="cursor: pointer"
									@click="currentTab = tabs[1].id"
								>
									{{ $t('Register here') }}
								</span>
							</p>
							<v-checkbox
								v-model="rememberMe"
								color="primary"
							>
								<template v-slot:label>
									<p class="text-caption">{{ $t('Remember me on this device') }}</p>
								</template>
							</v-checkbox>
						</div>
					</v-window-item>

					<v-window-item value="register">
						<RegisterForm
							:requestLoading="registerState.loading"
							:extraFieldsErrors="registerState.extraErrors"
							:isVisible="currentTab === 'register'"
							@submit="onRegister"
						/>

						<div class="mt-3">
							<p class="text-caption">
								{{ $t('Already registered?') }}
								<span
									class="text-primary"
									style="cursor: pointer"
									@click="currentTab = tabs[0].id"
								>
									{{ $t('Sign in here') }}
								</span>
							</p>
						</div>
					</v-window-item>
				</v-window>
			</v-card>
		</template>
	</div>
</template>

<script setup>
import LoginForm from '@/components/forms/auth/LoginForm.vue'
import RegisterForm from '@/components/forms/auth/RegisterForm.vue'

import { ref } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { storeToRefs } from 'pinia'

import useAuth from '@/composables/useAuth'

const emit = defineEmits({
	login: (payload) => payload.authAccessToken && payload.authRefreshToken,
	register: (payload) => payload.authAccessToken && payload.authRefreshToken,
})

const userStore = useUserStore()
const {
	currentUser,
	isEmailConfirmed,
} = storeToRefs(userStore)

const {
	loginState,
	registerState,
	resendingState,
	login,
	register,
	logoutUser,
	resendConfirmationEmail,
} =
	useAuth()

const tabs = [
	{
		title: 'Login',
		id: 'login',
	},
	{
		title: 'Register',
		id: 'register',
	},
]
const currentTab = ref(tabs[0].id)
const rememberMe = ref(true)

const onLogin = (payload) => {
	login({
		...payload,
		remember: rememberMe.value,
	})
		.then((tokens) => {
			emit('login', tokens)
		})
		.catch(() => {})
}

const onRegister = (payload) => {
	register(payload)
		.then((tokens) => {
			emit('register', tokens)
		})
		.catch(() => {})

	// if (isAuth) {
	// 	currentTab.value = 'login'
	// }
}
</script>

<style>
.auth-bg {
	background-image: url('/images/temp-image-bg.jpg');
	background-size: cover;
	background-position: center center;
}
</style>
